module.exports = __webpack_public_path__ + "img/汉熵智慧环卫管理平台.9dfc931b.png";